import { Req } from './types/requests'
import { Res } from './types/responses'
import _data from './utils/_data'

export const sdk = {
  createOfferRedemption: (params: Req['createOfferRedemption']) => {
    return _data
      .get(`offers/${params.id}/redeem`, params)
      .then((res: Res['offerRedemption']) => res)
  },

  getOffer: (params: Req['getOffer']) => {
    return _data
      .get(`offers/${params.id}/`, params)
      .then((res: Res['offer']) => {
        return res
      })
  },
  getOffers: (params: Req['getOffers']) => {
    return _data.get('offers/', params).then((res: Res['offers']) => {
      return res
    })
  },
  getTags: (params: Req['getTags']) => {
    return _data.get('tags/', params).then((res: Res['tags']) => {
      return res
    })
  },
  login: () => {
    // return _data.post('login/', params).then((res) => {
    //   return res
    // })
    return Promise.resolve()
  },
}
